import KoalaSelect, { KoalaSelectOption } from 'koala/components/Select';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ValueType } from 'react-select';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import theme from 'theme';
import { startOfQuarter, endOfQuarter, startOfYear, endOfYear, addYears, addMonths } from 'date-fns';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.x1};
  z-index: 2;
`;

type Props = {
  startDateChangeCallback: (date: Date | null) => void;
  finishDateChangeCallback: (date: Date | null) => void;
};

function ReflectionFilter(props: Props) {
  const { startDateChangeCallback, finishDateChangeCallback } = props;
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [finishDate, setFinishDate] = useState<Date | null>(null);
  const [filter, setFilter] = useState<string>('active');

  const handleChangeFilter = (value: ValueType<KoalaSelectOption, boolean>) => {
    const selectedOption = value as KoalaSelectOption;
    setFilter(selectedOption.value as string);

    let startDate = null,
      finishDate = null;
    if (selectedOption.value === 'active') {
      startDate = null;
      finishDate = null;
    } else if (selectedOption.value === 'previous_quarter') {
      startDate = startOfQuarter(addMonths(new Date(), -3));
      finishDate = endOfQuarter(addMonths(new Date(), -3));
    } else if (selectedOption.value === 'current_year') {
      startDate = startOfYear(new Date());
      finishDate = endOfYear(new Date());
    } else if (selectedOption.value === 'previous_year') {
      startDate = startOfYear(addYears(new Date(), -1));
      finishDate = endOfYear(addYears(new Date(), -1));
    } else if (selectedOption.value === 'custom') {
      startDate = null;
      finishDate = null;
    }
    setStartDate(startDate);
    startDateChangeCallback(startDate);
    setFinishDate(finishDate);
    finishDateChangeCallback(finishDate);
  };

  const options = [
    { label: 'Active', value: 'active' },
    { label: 'Previous Quarter', value: 'previous_quarter' },
    { label: 'Current Year', value: 'current_year' },
    { label: 'Previous Year', value: 'previous_year' },
    { label: 'Custom', value: 'custom' },
  ];

  const handleChangeStartDate = (date: Date | null) => {
    setStartDate(date);
    startDateChangeCallback(date);
  };

  const handleChangeFinishDate = (date: Date | null) => {
    setFinishDate(date);
    finishDateChangeCallback(date);
  };

  return (
    <Container>
      <KoalaSelect
        placeholder={t('workspaceProfile.filter')}
        options={options}
        handleChange={handleChangeFilter}
        size="small"
        selectedOption={options.find((option) => option.value === filter)}
      />
      {filter === 'custom' && (
        <>
          <DatePicker
            selected={startDate}
            onChange={handleChangeStartDate}
            dateFormat="d MMM yyyy"
            placeholderText={t('workspaceProfile.startDate') ?? 'Start Date'}
          />
          <DatePicker
            selected={finishDate}
            onChange={handleChangeFinishDate}
            dateFormat="d MMM yyyy"
            placeholderText={t('workspaceProfile.endDate') ?? 'Finish Date'}
          />
        </>
      )}
    </Container>
  );
}

export default ReflectionFilter;
